import { AppNS } from 'app';

import { Chip } from '@mui/material';

import { getStateNameById } from '../../config';

export interface InspectorStatusBadgeProps {
  state: AppNS.InspectorProfileState;
}

const CLASSES: Record<AppNS.InspectorProfileState, string> = {
  draft: 'outlined-gray flat',
  pending: 'warning flat',
  active: 'success-outlined flat',
  suspended: 'error-outlined flat',
  deactivated: 'error-outlined flat',
  resigned: 'error-outlined flat',
};

const getClass = (state: AppNS.InspectorProfileState): string => {
  return CLASSES[state] || 'warning flat';
};

export default function InspectorStatusBadge(props: InspectorStatusBadgeProps) {
  const { state } = props;

  const agencyState = state || 'pending';

  return <Chip clickable={false} className={getClass(agencyState)} label={getStateNameById(agencyState)} />;
}
